export default __webpack_public_path__ + "static/media/imbolglogo.92d06f98.png";